var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('slider-single'),_c('slider-multiple'),_c('slider-ranger-value'),_c('slider-rtl'),_c('slider-lazy'),_c('slider-disabled'),_c('slider-adsorb'),_c('slider-contained'),_c('slider-behavior'),_c('slider-color'),_c('slider-input'),_c('slider-vertical')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }